<template>
  <div class="summary-table mb-5">
    <b-modal hide-header no-close-on-esc no-close-on-backdrop ref="alert-cas" centered hide-footer>
      Vimos que você está tentando pesquisar as informações sobre o agente de CAS {{ cas }}. <br/>
      Para pesquisar este agente clique sobre o CAS abaixo.
      <b-row class='mt-3'>
        <b-col>
          <base-button
            danger
            block
            @click="searchWithoutExtractingCASNumber()" >
            Cancelar
          </base-button>
        </b-col>

        <b-col>
          <base-button
            success
            @click="extractStringCas" block>
            {{ cas }}
          </base-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="select-agents"
      id="select-agents"
      centered
      size='xl'
      :title="`Selecione o(s) agente(s) para vincular ao produto`"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <section class='modal-font-family'>
        <section v-if='agentsWithoutProduct && agentsWithoutProduct.length > 0'>
          <p>Abaixo estão os agentes que até o momento não foram agrupados a um produto.</p>
          <p>Caso o agente que você necessite não esteja indicado abaixo, então feche essa janela e adicione ele a partir do botão de pesquisa de agentes e em seguida repita o processo de adição de agente ao produto.</p>
          <hr/><br/>
          <section
            style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(25%, auto));'
          >
            <b-form-checkbox-group
              v-for='(agent, i) in agentsWithoutProduct'
              v-model='agentsSelected'
              :key='i'
              class='mr-3 pb-3'
              stacked
            >
              <section
                class='product'
               >
                <b-form-checkbox
                  :value='agent._id'
                >
                  <strong
                    class='text word-break'
                    :style="agentsSelected.includes(agent._id) ? 'color: #022245;font-weight: 700;': 'color: #262626; font-weight: 400;'"
                  >
                    {{ agent.name }}
                  </strong>
                </b-form-checkbox>
              </section>
            </b-form-checkbox-group>
          </section>
        </section>
        <section class="w-100" v-else>
          <h6>
            <strong>Todos os agentes já estão vinculados a um produto.</strong>
          </h6>
        </section>
      </section>
      <template #modal-footer>
        <b-container fluid class='w-100 modal-font-family'>
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button
                variant="danger"
                class="w-100"
                @click="closeModalSelectAgents()" >
                Cancelar
              </b-button>
            </b-col>
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-overlay
                :show='loadingAgents'
                rounded
                opacity='0.6'
                spinner-small
                spinner-variant='primary'
                class='d-inline-block w-100'
              >
                <b-button
                  @click='addAgentsToTheProduct()'
                  variant="success"
                  class="w-100"
                  :disabled='!agentsSelected || agentsSelected.length <= 0'
                >
                  Adicionar
                </b-button>
              </b-overlay>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-modal
      id='add-agents-to-product'
      ref='add-agents-to-product'
      header-bg-variant='info'
      header-text-variant='light'
      title='Como deseja prosseguir?'
      size='xl'
    >
      <section class='modal-font-family m-0 p-0'>
        <p><strong>Você pode adicionar o(s) agente(s) a um produto já cadastrado ou então cadastrar um novo produto para vincular os agentes selecionados.</strong></p>
      </section>

      <template #modal-footer>
        <b-container fluid class='w-100 modal-font-family'>
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button
                variant='success'
                class='w-100 mr-1'
                @click='showModalSelectProduct()'
              >
                Adicionar agente(s) a um produto cadastrado
              </b-button>
            </b-col>
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button
                variant='success'
                class='w-100'
                @click="addAgentsProduct()"
              >
                Cadastrar produto
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-modal
      id='select-product'
      ref='select-product'
      header-bg-variant='info'
      header-text-variant='light'
      title='Selecionar produto'
      size='xl'
    >
      <section class='modal-font-family m-0 p-0'>
        <p><strong>Escolha o produto ao qual deseja adicionar o(s) agente(s) selecionados.</strong></p>
        <section class="mt-2">
          <label for='selectedCompany'><strong>Selecione um produto</strong></label>
          <b-form-select
            id='selectedCompany'
            v-model='productId'
            :options='products'
            class='mb-3'
            style='height: 50px'
            value-field='_id'
            text-field='name'
          >
            <template #first>
              <b-form-select-option :value='null' disabled>Selecione um produto</b-form-select-option>
            </template>
          </b-form-select>
        </section>
      </section>
      <template #modal-footer>
        <b-container fluid class='w-100 modal-font-family'>
          <b-row cols="12">
            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-button
                variant="danger"
                class="w-100"
                @click="closeModalSelectProduct()" >
                Cancelar
              </b-button>
            </b-col>

            <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="12" xl="6">
              <b-overlay
                :show='loadingAgents'
                rounded
                opacity='0.6'
                spinner-small
                spinner-variant='primary'
                class='d-inline-block w-100'
              >
                <b-button
                  @click='addAgentProductSelected()'
                  variant='success'
                  class="w-100"
                  :disabled='!productId'
                >
                  Adicionar
                </b-button>
              </b-overlay>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-overlay
      :show='lookingForAgents'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <table class="text-center w-100 mt-1 summary-table" >
        <thead class='sticky'>
          <tr style="background: #FFFFFF">
            <th :colspan="importedCompany && importedCompany._id ? 9 : 9" class='container-tab-buttons' >
              <TabButtons></TabButtons>
            </th>
          </tr>

          <tr class='search-agent' >
            <th class="border-radius-th" :colspan="importedCompany && importedCompany._id ? 9 : 8">
              <b-container fluid class='modal-font-family m-0 p-0 w-100'>
                <b-row no-gutters cols="12" class='px-1' align-content="center">
                  <b-col class="m-0 p-0 pr-1 py-1" sm="1" md="1" lg="1" xl="1"> </b-col>

                  <b-col class="m-0 p-0 pr-1 py-1" sm="6" md="6" lg="6" xl="6">
                    <div class='d-flex justify-content-between align-items-center px-2 w-100' >
                      <section
                        class="w-100"
                        ref="containerAgenBaseAutocomplete"
                      >
                        <b-form-input
                          type="search"
                          v-model="agent"
                          id="agenBaseAutocomplete"
                          placeholder="Pesquise um CAS: Agente para iniciar"
                          class="mb-2 mb-sm-2 legal-search pr-2 w-100"
                          ref="agenBaseAutocomplete"
                          @input="clear"
                          @focus="showAgentes = true"
                        >
                        </b-form-input>

                        <div v-if="showAgentes" class="position-relative w-100">
                          <ul class="list-agents position-absolute w-100">
                            <section id="container-li-agents">
                              <li
                                @click="selectByAgente(agent)"
                                class="cursor-pointer"
                                v-for="(agent, i) in filterAgents"
                                :key="`${agent._id}_${i}`"
                              >
                                <span>{{agent.searchMatched}}</span>
                              </li>
                            </section>
                          </ul>
                        </div>
                      </section>
                      <section class='ml-2 d-flex align-items-start'>
                        <b-spinner class='loading mb-2' v-if="loading" variant="primary" label="Spinning"></b-spinner>

                        <section v-else class='d-flex'>
                          <b-tooltip custom-class="custom-tooltip" target="popover-target-1" placement="top" triggers="hover">
                            Para pesquisar agentes químicos digite o NOME/SINÔNIMO do
                            agente químico ou então o seu CAS. Não realize a pesquisa
                            digitando o CAS e o nome do agente juntos. Caso a sua pesquisa
                            seja feita através do número CAS, por favor, digite o CAS no
                            seguinte padrão: 2 ou mais dígitos - 2 dígitos - 1 dígito.
                            Exemplo: 50-00-0, 108-88-3, 64742-47-8. Os números CAS não
                            possuem espaços entre os dígitos e os traços.
                          </b-tooltip>

                          <b-icon
                            class='ml-1 mb-2'
                            font-scale="2.2"
                            icon="question-circle-fill"
                            id="popover-target-1"
                            variant="info"
                          >
                          </b-icon>

                          <section
                            style='margin-top: -8px'
                            class='ml-3'
                          >
                            <strong
                              v-if='summaryMeta && summaryMeta.total'
                              class='text-white'
                            >
                              Página <br/>
                              {{summaryMeta.skip}} de {{summaryMeta.totalPage}}
                            </strong>
                          </section>
                        </section>
                      </section>
                    </div>
                  </b-col>

                  <b-col class="m-0 p-0 pr-1 py-1" sm="5" md="5" lg="5" xl="5">
                    <div class='d-flex justify-content-end pr-4'>
                      <div class='title-legend-summary'><span>Legendas </span></div>
                      <div class="legends-summary">
                        <span>
                          <img width='18' height='14' src='../../assets/images/consta.svg'  alt='Conta'/> consta
                        </span>
                        <span>
                          <img width='14' height='14' src='../../assets/images/naoConsta.svg'  alt='Não consta'/> não consta
                        </span>
                        <span>
                          <img width='16' height='16' src='../../assets/images/classificacao.svg'  alt='Em classificação'/> em classificação
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </th>
          </tr>

          <tr class='risk-chemical-header-row w-100'>
            <th :colspan="importedCompany && importedCompany._id ? 9 : 8" class="w-100">
              <div class='d-flex justify-content-between align-items-center'>
                <strong class='risk-chemical-title'>Riscos Químicos</strong>
                <button
                  type='button'
                  class='risk-chemical-toggle'
                  :class="userPreferences && userPreferences.tabSummaryChemicalRiskOpen
                    ? ''
                    : 'pulse-global'"
                  @click='toggleChemicalExpanded()'
                >
                  {{
                    userPreferences && userPreferences.tabSummaryChemicalRiskOpen
                      ? 'Recolher informações'
                      : 'Expandir informações'
                  }}
                </button>
              </div>
            </th>
          </tr>

          <tr class='risk-chemical-header-row w-100' v-if='userPreferences && userPreferences.tabSummaryChemicalRiskOpen'>
            <th class='width-8-percent p-2'>
              <b-form-checkbox :checked="selectedAll" @change="selectAll()">
                Selecionar <br/> todos
              </b-form-checkbox>
            </th>
            <th colspan='2' class='width-44-percent'>
              CAS: Agente
              <b-dropdown
                variant="outline-dange"
                menu-class='w-100 options'
                class='btn-options'
                no-flip
                no-caret
              >
                <template #button-content>
                  <b-icon
                    icon='arrow-down-short'
                    font-scale="1.5"
                    variant='info'>
                  </b-icon>
                </template>
                <span class='ml-4'>Organizar os agentes por:</span>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                  @click="orderBy('nomeAgente')"
                >
                  <section class='d-flex justify-content-between align-items-center'>
                    <span>Ordem alfabética por nome do agente</span>
                    <b-icon
                      v-if="summaryMeta && summaryMeta.orderBy && summaryMeta.orderBy === 'nomeAgente'"
                      icon='check'
                      variant='success'
                    >
                    </b-icon>
                  </section>
                </b-dropdown-item>

                <b-dropdown-item
                  @click="orderBy('numeroCas')"
                >
                  <section class='d-flex justify-content-between align-items-center'>
                    <span>Ordem numérica por cas</span>
                    <b-icon
                      v-if="summaryMeta && summaryMeta.orderBy && summaryMeta.orderBy === 'numeroCas'"
                      icon='check'
                      variant='success'
                    >
                    </b-icon>
                  </section>
                </b-dropdown-item>

                <b-dropdown-item
                  @click="orderBy('nomeProduto')"
                >
                  <section class='d-flex justify-content-between align-items-center'>
                    <span>Ordem alfabética por nome do produto (ordenando os produtos)</span>
                    <b-icon
                      v-if="summaryMeta && summaryMeta.orderBy && summaryMeta.orderBy === 'nomeProduto'"
                      icon='check'
                      variant='success'
                    >
                    </b-icon>
                  </section>
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <th class='width-8-percent p-2'>ACGIH</th>
            <th class='width-8-percent no-wrap p-2'>NR 15</th>
            <th class='width-8-percent p-2'>LINACH</th>
            <th class='width-8-percent p-2'>ESOCIAL - Tabela 24</th>
            <th class='width-8-percent p-2'>DECRETO 3048/99 - Anexo IV</th>
            <th v-if='importedCompany && importedCompany._id' class='width-8-percent p-2'>Ações</th>
          </tr>
        </thead>

        <tbody  v-if='userPreferences && userPreferences.tabSummaryChemicalRiskOpen'>
          <template  v-for="product in legalConsultationAgentsGroupedByProduct">
            <template v-for="(item, indexLegalSearche) in product.legalSearches" >
              <tr class='risk-chemical-tbody' :key="`${indexLegalSearche}_item_${item.legalSearchId}`">
                <td
                  class="py-3"
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                  ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word;`
                  : `word-wrap: break-word`}`"
                >
                  <b-form-checkbox
                    @change="selectAgentRemove(item)"
                    :checked="checked(item.legalSearchId)">
                  </b-form-checkbox>
                </td>

                <template v-if="product.product._id !==  '-' ">
                  <td
                    class='w-40'
                    v-if='item.index < 1'
                    :rowspan="product.legalSearches.length"
                  >
                    <section v-if="product.product._id !==  '-'">
                      <section v-if="product.product._id === idDefault">
                        <a
                          :style="selectedMoreThanOneProduct ? 'pointer-events: none' : ''"
                          v-if='importedCompany && importedCompany._id'
                          class='word-break add-agent-prouct'
                          @click="showModalAddAgentsProduct()"
                        >
                          Adicionar agente(s) <br/> ao produto
                        </a>
                      </section>

                      <section v-else>
                        <p class='word-break' v-if="!lookingForAgents">
                          <span>
                            <strong>Produto:</strong> {{ product.product.name}}
                          </span>
                          <br/>
                          <br/>
                          <b-popover
                            :target="`${product.product._id}_${product.product.createdAt}`"
                            placement="righttop"
                            triggers="hover focus"
                          >
                            <section v-if="product.hierarchical && product.hierarchical.length > 0">
                              <section
                                v-for="(hierarchical, i) in product.hierarchical"
                                :key="`${hierarchical._id}_${i}` "
                              >
                                <section v-if="hierarchical && hierarchical.roles && hierarchical.roles.length > 0">
                                  <section
                                    v-for="(role, y) in hierarchical.roles"
                                    :key="`${role._id}_${y}` "
                                  >
                                    <section
                                      class="d-flex align-items-center my-2"
                                      v-for="(product, x) in role.products"
                                      :key="`${product._id}_${x}` "
                                    >
                                      <svg width="10" height="14" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.16124 0.84313C0.109734 0.795422 0.0694692 0.739302 0.0427424 0.677974C0.0160155 0.616645 0.00335045 0.55131 0.00547096 0.485697C0.00759147 0.420085 0.0244558 0.35548 0.0551008 0.295573C0.0857459 0.235665 0.129571 0.181627 0.184076 0.136544C0.23858 0.0914618 0.302695 0.0562174 0.372761 0.0328233C0.442826 0.00942931 0.517469 -0.0016562 0.592429 0.000199884C0.667389 0.00205597 0.741198 0.0168172 0.80964 0.0436408C0.878083 0.0704645 0.939819 0.108825 0.991324 0.156533L5.84395 4.65389C5.94416 4.74667 6 4.86951 6 4.99719C6 5.12487 5.94416 5.24771 5.84395 5.34049L0.991324 9.83835C0.940159 9.8871 0.878436 9.92647 0.809742 9.95417C0.741048 9.98186 0.666751 9.99733 0.591168 9.99969C0.515584 10.002 0.44022 9.99122 0.369454 9.96786C0.298687 9.9445 0.233928 9.90907 0.178939 9.86362C0.12395 9.81816 0.0798265 9.7636 0.0491315 9.7031C0.0184365 9.6426 0.00178209 9.57736 0.00013535 9.51117C-0.00151138 9.44499 0.0118823 9.37918 0.0395388 9.31756C0.0671954 9.25595 0.108563 9.19976 0.16124 9.15225L4.64392 4.99719L0.16124 0.84313Z" fill="#808080"/>
                                      </svg>
                                    <p class="mb-0 ml-2 name-sector-role">
                                      <span>Setor:</span> {{product.sectorRole.sector.name}} -
                                      <span>Cargo:</span> {{product.sectorRole.role.name}}
                                    </p>
                                    </section>
                                  </section>
                                </section>
                              </section>
                            </section>

                            <section v-if="product.hierarchical && product.hierarchical.length > 0" >
                              <section
                                v-for="(hierarchical, i) in product.hierarchical"
                                :key="`${hierarchical._id}_${i}` "
                              >
                                <section
                                  v-show="hierarchical.rolesProductLegalConsultation && hierarchical.rolesProductLegalConsultation.length > 0"
                                  v-for="(roleProductLegalConsultation, i) in hierarchical.rolesProductLegalConsultation"
                                  :key="`${roleProductLegalConsultation._id}_${i}` "
                                >
                                  <section class="d-flex align-items-center my-2" v-if="roleProductLegalConsultation && roleProductLegalConsultation.role && roleProductLegalConsultation && roleProductLegalConsultation.role.name">
                                    <svg width="10" height="14" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0.16124 0.84313C0.109734 0.795422 0.0694692 0.739302 0.0427424 0.677974C0.0160155 0.616645 0.00335045 0.55131 0.00547096 0.485697C0.00759147 0.420085 0.0244558 0.35548 0.0551008 0.295573C0.0857459 0.235665 0.129571 0.181627 0.184076 0.136544C0.23858 0.0914618 0.302695 0.0562174 0.372761 0.0328233C0.442826 0.00942931 0.517469 -0.0016562 0.592429 0.000199884C0.667389 0.00205597 0.741198 0.0168172 0.80964 0.0436408C0.878083 0.0704645 0.939819 0.108825 0.991324 0.156533L5.84395 4.65389C5.94416 4.74667 6 4.86951 6 4.99719C6 5.12487 5.94416 5.24771 5.84395 5.34049L0.991324 9.83835C0.940159 9.8871 0.878436 9.92647 0.809742 9.95417C0.741048 9.98186 0.666751 9.99733 0.591168 9.99969C0.515584 10.002 0.44022 9.99122 0.369454 9.96786C0.298687 9.9445 0.233928 9.90907 0.178939 9.86362C0.12395 9.81816 0.0798265 9.7636 0.0491315 9.7031C0.0184365 9.6426 0.00178209 9.57736 0.00013535 9.51117C-0.00151138 9.44499 0.0118823 9.37918 0.0395388 9.31756C0.0671954 9.25595 0.108563 9.19976 0.16124 9.15225L4.64392 4.99719L0.16124 0.84313Z" fill="#808080"/>
                                    </svg>
                                    <p class="mb-0 ml-2 name-sector-role">
                                    <span>Cargo:</span> {{roleProductLegalConsultation.role.name}}
                                    </p>
                                  </section>
                                </section>
                              </section>
                            </section>
                          </b-popover>
                          <a
                            :id="`${product.product._id}_${product.product.createdAt}`"
                            class="add-agent-prouct"
                            v-if="product.hierarchical && product.hierarchical.length > 0"
                          >
                            Passe o mouse para exibir os vínculos
                          </a>
                        </p>

                        <section class='d-flex justify-content-center'>
                          <section class='mb-2' v-if="synergisticRiskProducts && synergisticRiskProducts.length > 0 && !!synergisticRiskProducts.find((x) => x.product === product.product._id)">
                            <b-tooltip
                              :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_synergisticRiskProducts`"
                              custom-class="custom-tooltip"
                              placement="auto"
                              triggers="hover"
                            >
                              <strong>Este produto contém agentes químicos que afetam de forma acumulativa o mesmo órgão ou sistema alvo:</strong> <br/>
                              <ul class='phrases mt-2'>
                                <li
                                  v-for='phrase in synergisticRiskProducts.find((x) => x.product === product.product._id).phrases'
                                  :key='phrase'
                                >
                                  {{phrase}}
                                </li>
                              </ul>
                            </b-tooltip>

                            <button
                              class='btn-synergistic-risk'
                              :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_synergisticRiskProducts`"
                            >
                              <svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.034 8.5645L10.6878 1.2175C10.4057 0.93712 10.0242 0.779739 9.62651 0.779739C9.22882 0.779739 8.8473 0.93712 8.56526 1.2175L1.21901 8.5645C0.93863 8.84654 0.78125 9.22806 0.78125 9.62575C0.78125 10.0234 0.93863 10.405 1.21901 10.687L8.56601 18.0333C9.14952 18.6168 10.1035 18.6168 10.6885 18.0333L18.0355 10.6863C18.3151 10.4041 18.4719 10.023 18.4719 9.62575C18.4719 9.22855 18.3151 8.84741 18.0355 8.56525L18.034 8.5645ZM9.02876 4.735C9.19376 4.55725 9.40376 4.468 9.66176 4.468C9.91976 4.468 10.1298 4.5565 10.2948 4.73275C10.4598 4.909 10.5423 5.13025 10.5423 5.3965C10.5423 5.626 10.4673 6.39625 10.315 7.708C10.165 9.0205 10.03 10.288 9.91751 11.512H9.37976C9.27851 10.2873 9.15476 9.01975 9.00476 7.708C8.85626 6.3955 8.78126 5.626 8.78126 5.3965C8.78126 5.134 8.86376 4.915 9.02876 4.7365V4.735ZM10.3263 14.35C10.1403 14.53 9.91901 14.62 9.66176 14.62C9.40451 14.62 9.18326 14.53 8.99801 14.35C8.81276 14.1685 8.72051 13.9495 8.72051 13.6923C8.72051 13.435 8.81276 13.2138 8.99801 13.0285C9.18401 12.8425 9.40526 12.7495 9.66251 12.7495C9.91976 12.7495 10.141 12.8425 10.3263 13.0285C10.5138 13.2138 10.606 13.435 10.606 13.6923C10.606 13.9495 10.513 14.1685 10.327 14.3493L10.3263 14.35Z" fill="#022245"/>
                              </svg>
                            </button>
                          </section>

                          <section>
                            <b-tooltip
                              :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_agent`"
                               placement="auto"
                              triggers="hover"
                            >
                              <strong>Adicionar agentes a esse produto</strong>
                            </b-tooltip>

                            <b-icon
                              @click='showModalSelectAgents(product)'
                              :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_agent`"
                              class='ml-3 cursor-pointer' variant='info' font-scale="2.1" icon='plus-square-fill'
                            >
                            </b-icon>
                          </section>
                        </section>
                        <a
                          :style="selectedMoreThanOneProduct || disableProduct ? 'pointer-events: none' : ''"
                          v-if='importedCompany && importedCompany._id && showAddAgents(product)'
                          class='word-break add-agent-prouct'
                          @click="callGlobalCustomEvent('showModalAddProduct')"
                        >
                          Adicionar agente(s) <br/> ao produto: {{product.product.name}}
                        </a>

                        <section v-if='disableProduct' class='d-flex align-items-center justify-content-center mt-2'>
                          <b-spinner
                            class='loading-button'
                            variant='info'
                            label="Spinning">
                          </b-spinner>
                          <strong class='ml-2 ' style='color: #04A8F3'>Adicionando...</strong>
                        </section>
                      </section>
                    </section>
                  </td>
                </template>

                <template v-else>
                  <td class='w-40'>
                    <section class='px-2'>
                      <a
                        v-if='importedCompany && importedCompany._id'
                        class='word-break add-agent-prouct'
                        @click="addAgentProduct(item.legalSearchId)"
                      >
                        Adicionar agente <br/> ao produto
                      </a>

                      <p
                        v-else
                        class='word-break '
                      >
                        -
                      </p>
                    </section>
                  </td>
                </template>

                <td
                  class='w-60'
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                  ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word;`
                  : `word-wrap: break-word`}`"
                  :id="`tag_0_${item.legalSearchId}`"
                >

                  <b-tooltip
                    :target="`${item.legalSearchId}-${item.cas}-${item.index}-searchId`"
                    custom-class="custom-tooltip"
                    placement="auto"
                    triggers="hover"
                  >
                    <section
                      class='p-2'
                      v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                    >
                    <span
                      class='text-white'
                      style='font-size: 15px'
                    >
                      Este agente consta na NR 15 com o seguinte nome:
                      {{ item.attachment11 && item.attachment11.group
                      ? item.attachment11.group
                      : item.nameAttachment11 ? item.nameAttachment11: '-'
                      }}
                    </span><br/><br/>
                    </section>

                    <section
                      class='p-2'
                      v-if='item.acgih && item.agent'
                    >
                      <span
                        class='text-white'
                        style='font-size: 15px'
                      >
                        Este agente já foi citado na ACGIH com o nome:
                        {{ item.agent ? item.agent : '-' }}
                      </span>
                      <br/>
                      <br/>
                    </section>

                    <a
                      :href="`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`"
                      target='_blank'
                      class='link-pubchem-cas p-2'
                    >
                    <span>
                      Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                    </span>
                    </a>
                  </b-tooltip>

                  <a
                    href="#" class='hover_links word-break'
                    :id="`${item.legalSearchId}-${item.cas}-${item.index}-searchId`"
                  >
                    <span class='word-break'>{{ model.getsearchId('searchId', item) }}</span>

                    <b-icon
                      class='ml-1'
                      font-scale="1.2"
                      icon="info-circle-fill"
                      variant="info"
                    >
                    </b-icon>
                  </a>
                </td>

                <td
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('acgih')}`
                    : `word-wrap: break-word`}; ${styleWidth('acgih')}`"
                  :id="`tag_1_${item.legalSearchId}`"
                >
                  <b-tooltip
                    :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_acgih`"
                    placement="auto"
                    triggers="hover"
                  >
                    <span
                      v-if="model.getExist('acgih', item) == 'consta'"
                    >
                      O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('acgih', item) == 'naoConsta'"
                    >
                      O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('acgih', item) == 'classificacao'"
                    >
                      <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                    </span>

                  </b-tooltip>

                  <img
                    :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_acgih`"
                    width='18'
                    height='16'
                    v-bind:src="require(`../../assets/images/${model.getExist('acgih', item)}.svg`)"
                    alt=''
                  />
                </td>

                <td
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('nr15')}`
                    : `word-wrap: break-word`}; ${styleWidth('nr15')}`"
                  :id="`tag_2_${item.legalSearchId}`"
                >
                  <b-tooltip
                    :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_nr15`"
                    placement="auto"
                    triggers="hover"
                  >
                    <span
                      v-if="model.getExist('nr15', item) == 'consta'"
                    >
                      O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('nr15', item) == 'naoConsta'"
                    >
                      O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('nr15', item) == 'classificacao'"
                    >
                      <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                    </span>

                  </b-tooltip>

                  <img
                    :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_nr15`"
                    width='18'
                    height='16'
                    v-bind:src="require(`../../assets/images/${model.getExist('nr15', item)}.svg`)"
                    alt=''
                  />
                </td>

                <td
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('linach')}`
                    : `word-wrap: break-word`}; ${styleWidth('linach')}`"
                  :id="`tag_3_${item.legalSearchId}`"
                >
                  <b-tooltip
                    :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_linach`"
                    placement="auto"
                    triggers="hover"
                  >
                    <span
                      v-if="model.getExist('linach', item) == 'consta'"
                    >
                      O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('linach', item) == 'naoConsta'"
                    >
                      O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('linach', item) == 'classificacao'"
                    >
                      <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                    </span>

                  </b-tooltip>

                  <img
                    :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_linach`"
                    width='18'
                    height='16'
                    v-bind:src="require(`../../assets/images/${model.getExist('linach', item)}.svg`)"
                    alt=''
                  />
                </td>

                <td
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('esocial')}`
                    : `word-wrap: break-word`}; ${styleWidth('esocial')}`"
                  :id="`tag_4_${item.legalSearchId}`"
                >
                  <b-tooltip
                    :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_esocial`"
                    placement="auto"
                    triggers="hover"
                  >
                    <span
                      v-if="model.getExist('esocial', item) == 'consta'"
                    >
                      O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('esocial', item) == 'naoConsta'"
                    >
                      O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('esocial', item) == 'classificacao'"
                    >
                      <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                    </span>
                  </b-tooltip>
                  <img
                    :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_esocial`"
                    width='18'
                    height='16'
                    v-bind:src="require(`../../assets/images/${model.getExist('esocial', item)}.svg`)"
                    alt=''
                  />
                </td>

                <td
                  :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                    ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('decree3048')}`
                    : `word-wrap: break-word`}; ${styleWidth('decree3048')}`"
                  :id="`tag_5_${item.legalSearchId}`"
                >
                  <b-tooltip
                    :target="`${item.cas}_${item.legalSearchId}_${product.product._id}_decree3048`"
                    placement="auto"
                    triggers="hover"
                  >
                    <span
                      v-if="model.getExist('decree3048', item) == 'consta'"
                    >
                      O agente <strong>está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('decree3048', item) == 'naoConsta'"
                    >
                      O agente <strong>não está</strong> na referência indicada na coluna. Veja detalhes nas abas.
                    </span>

                    <span
                      v-if="model.getExist('decree3048', item) == 'classificacao'"
                    >
                      <strong>Classificação em andamento.</strong> Consulte-nos para mais informações.
                    </span>
                  </b-tooltip>

                  <img
                    :id="`${item.cas}_${item.legalSearchId}_${product.product._id}_decree3048`"
                    width='18'
                    height='16'
                    v-bind:src="require(`../../assets/images/${model.getExist('decree3048', item)}.svg`)"
                    alt=''
                  />
                </td>

                <template v-if='importedCompany && importedCompany._id'>
                  <template v-if="product.product._id !== '-' && product.product._id !== idDefault">
                    <td
                      v-if='item.index < 1'
                      :rowspan="product.legalSearches.length"
                      :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                        ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('actions')}`
                        : `word-wrap: break-word`}; ${styleWidth('actions')}`"
                    >
                      <img
                        @click="callGlobalCustomEvent('showModalAddProduct', {productId: product.product._id})"
                        v-b-tooltip.lefttop.hover
                        title='Clique aqui para editar o produto.'
                        style='cursor: pointer'
                        class="mr-1 button-remove"
                        width='28'
                        height='28'
                        src='../../assets/images/bxs_edit.svg'
                        alt=''
                      />
                    </td>
                  </template>
                  <template v-else>
                    <td
                      :style="`${itemsToRemove.find((x) => x === item.legalSearchId)
                        ? `background: rgba(4, 168, 243, 0.1); word-wrap: break-word; ${styleWidth('actions')}`
                        : `word-wrap: break-word`}; ${styleWidth('actions')}`"
                    >
                      <img
                        style='cursor: pointer'
                        class="mr-1 button-remove"
                        @click="$emit('remove-confirmation', item.legalSearchId)"
                        width='24'
                        height='24'
                        src='../../assets/images/lixeira.svg'
                        alt=''
                      />

                    </td>
                  </template>
                </template>
              </tr>
            </template>
          </template>
          <tr style="background: #EDEDED" v-if='summaryMeta.total > agentsPerPage'>
            <td :colspan="importedCompany && importedCompany._id ? 9 : 8">
              <div class='w-100 mt-3'>
                <b-pagination
                  align="center"
                  :per-page='perPage'
                  v-model="summaryMeta.skip"
                  :total-rows="summaryMeta.total"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  @page-click='setPage'
                  size="lg"
                  aria-controls="my-table"
                  class="custom-pagination"
                >
                  <template #page="{ page, active }">
                    <b v-if="active">{{ page }}</b>
                    <i v-else>{{ page }}</i>
                  </template>
                </b-pagination>
              </div>
            </td>
          </tr>
        </tbody>
      </table>


      <AgentsByRisk
        id="agentsByPhysicalRisk"
        risk="fisico"
        @loadAgentsByRisk="loadAgentsByRisk"
      >
      </AgentsByRisk>

      <AgentsByRisk
        id="agentsByBiologicalRisk"
        risk="biologico"
        @loadAgentsByRisk="loadAgentsByRisk"
      >
      </AgentsByRisk>
      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner
            style='width: 3rem; height: 3rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
        </div>
      </template>
    </b-overlay>
    <section v-if='!legalConsultationAgentsGroupedByProduct || legalConsultationAgentsGroupedByProduct.length <= 0'>
      <h6 class='text-center my-4' v-if='!lookingForAgents'>
        <span v-if='appliedFilters'>
          Não foi encontrado agentes baseado nos filtros selecionados.
        </span>

        <span v-else>
           Você ainda não possui agentes cadastrados, pesquise pelo número CAS ou nome do agente para adicionar agente na sua lista.
        </span>
      </h6>
    </section>
  </div>
</template>

<script>
import LegalSearchSummary from '@/models/LegalSearchSummary'
import _ from 'underscore'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { agentCASNumberIsValid, extractCASNumber, extractString } from '../../utils/validateCASAgent'
import useVuelidate from '@vuelidate/core'
import TabButtons from '../../components/LegalSearch/components/TabButtons.vue'
import eventBus from '@/utils/eventBus'
import {driver} from 'driver.js'
import "driver.js/dist/driver.css";
import AgentsByRisk from '@/components/LegalSearch/Summary/PhysicalRisk/AgentsByRisk.vue'
export default {
  async mounted() {
    this.$refs.agenBaseAutocomplete.$el.addEventListener('keyup', (e) => {
      const typedValue = this.$refs.agenBaseAutocomplete.value.replace(/^0+/,'')
      const searchedByCas = agentCASNumberIsValid(typedValue);
      if(searchedByCas) {
        this.$refs.agenBaseAutocomplete.value = this.$refs.agenBaseAutocomplete.value.replace(/^0+/,'')
        this.$refs.agenBaseAutocomplete.value = this.$refs.agenBaseAutocomplete.value.replace(' ', '')
      }
      this.agent = this.$refs.agenBaseAutocomplete.value
    })
    document.addEventListener("click", this.handleClickOutsideContainerAgenBaseAutocomplete);
    this.$parent.$on('addChemicalAgentLegalConsultation', this.add);
    eventBus.$on('updateTab', this.closeTour)
    this.$watch('$route', this.closeTour)
    await this.loadAgentsByRisk()
    await this.loadTabSummaryRiskPreferences()
    this.manageTour()
    await this.handlGetEventActive()
  },
  name: 'SummaryTable',
  async beforeDestroy() {
    try {
      this.closeTour()
      this.summary.forEach((x) => {
        if (!x.registeredProduct) {
          delete x.product
        }
      })
      await this.groupAgents(this.summary)
      await this.setSlectedAgents([])
      document.removeEventListener("click", this.handleClickOutsideContainerAgenBaseAutocomplete);
      eventBus.$off('updateTab', this.closeTour)
    } catch (e) {

    }
  },
  async created () {},
  components: {
    AgentsByRisk,
    TabButtons
  },
  props: {
    selectedAll: { type: Boolean },
    itemsToRemove: { type: Array },
    limitAgentsAddedInAgentSelection: { type: Number, default: 1000 },
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      model: LegalSearchSummary,
      cas: '',
      loading: false,
      hidden: true,
      disabled: true,
      removeAll: '',
      removeItems: [],
      maxMatchesSelect: 100,
      agent: '',
      showAgentes: false,
      summaryFilter: [],
      summaryFilterMeta: {
        search: '',
        skip: 1
      },
      lookingForAgentsFilter: false,
      agents: [],
      removeItem: '',
      hitted: false,
      inventoryMessage: '',
      inventory: [],
      message: '',
      options: [],
      legalSearchesId: [],
      alertvariant: 'success',
      dailySearches: {},
      modal: {
        current: "ModalRequestAgent",
        open: false
      },
      casSearch: '',
      idDefault: 123456789,
      agentsSelected: [],
      product: Object,
      loadingAgents: false,
      legalSearchId: null,
      productId: null,
      products: [],
      driver: null,
      showTour: false,
      userPreferencesId: null,
      roles: [],
      selectedRoleId: null,
      loadingBindRole: false,
    }
  },
  methods: {
    ...mapActions('userPreferences', {
      handleUpdateTabSummaryRiskOpen: 'handleUpdateTabSummaryRiskOpen',
      handleGetUserPreferences: 'handleGetUserPreferences',
    }),
    ...mapActions('userPlans', {
      handleGetAddedAgentsLimitation: 'handleGetAddedAgentsLimitation',
    }),
    ...mapActions('objectivesAnalysis', {
      handleUpdateChangedAgentsLegalConsultation: 'handleUpdateChangedAgentsLegalConsultation',
    }),
    ...mapActions('legalSearch', {
      handleResetSummaryMeta: 'handleResetSummaryMeta',
      setSkip: 'setSkip',
      summaryClear: 'summaryClear',
      handleSetSummaryMetaOrderBy: 'handleSetSummaryMetaOrderBy',
      setSlectedAgents: 'setSlectedAgents',
      setLegalConsultationAgentsGroupedByProduct: 'setLegalConsultationAgentsGroupedByProduct',
      setLegalConsultationAgentsGroupedByProductFilter: 'setLegalConsultationAgentsGroupedByProductFilter',
      addAgentsStartList: 'addAgentsStartList',
      resetAgentsStartList: 'resetAgentsStartList',
      handleGetLoadAgentsByRisk: 'handleGetLoadAgentsByRisk',
      setLookingForAgents: 'setLookingForAgents',
    }),
    ...mapActions('searchAgents', {
      handleCreateSearchAgents: 'handleCreateSearchAgents',
    }),
    ...mapActions('event', {
      handlGetEventActive: 'handlGetEventActive',
    }),
    ...mapActions('companyLegalConsultation', {
      handleAddAgentCompanyLegalConsultation: 'handleAddAgentCompanyLegalConsultation',
      handleUpdateAgentsCompanyLegalConsultation: 'handleUpdateAgentsCompanyLegalConsultation',
    }),
    ...mapActions('freeModeAgents', {
      handleAddAgentsFreeModeAgents: 'handleAddAgentsFreeModeAgents',
    }),
    ...mapActions('productLegalConsultation', {
      handleCreateProductLegalConsultation: 'handleCreateProductLegalConsultation',
      handleAddAgentProductLegalConsultation: 'handleAddAgentProductLegalConsultation',
      handleGetProductLegalConsultation: 'handleGetProductLegalConsultation',
      handleUpdateProductLegalConsultation: 'handleUpdateProductLegalConsultation',
      setDisableProduct: 'setDisableProduct',
      handleGetProductLegalConsultationByCompany: 'handleGetProductLegalConsultationByCompany',
    }),
    ...mapActions('user', {
      handleUpdateHasSeenTourlAfter3Logins: 'handleUpdateHasSeenTourlAfter3Logins'
    }),
    ...mapActions('role', {
      handleGetByCompany: 'handleGetByCompany',
    }),
    async loadTabSummaryRiskPreferences() {
      try {
        await this.handleGetUserPreferences(this.user.id)
        const { _id } = this.userPreferences || {}
        this.userPreferencesId = _id
      } catch (e) {
        //
      }
    },

    async toggleChemicalExpanded() {
      try {
        await this.setLookingForAgents(true)
        await this.handleUpdateTabSummaryRiskOpen({
          _id: this.userPreferencesId,
          tabSummaryChemicalRiskOpen: !this.userPreferences?.tabSummaryChemicalRiskOpen,
        })
        await this.handleGetUserPreferences(this.user.id)
      } catch (e) {
        console.log(e)
      } finally {
        await this.setLookingForAgents(false)
      }
    },

    async setPage(event, page) {
      this.previousPage = this.summaryMeta.skip
      await this.summaryClear()
      await this.setSkip(page)
      await this.load()
    },

    addStepsTour(steps) {
      if(!this.showTour){
        return
      }
      this.refreshTour()
      this.driver = driver({
        allowClose: false,
        showButtons: [],
        showProgress: false,
        overlayOpacity: 0.8,
        steps
      });
      this.driver.drive();
    },

    createHighlightBox(legalSearchId, quantityDiv){
      const elements = []
      for (let i = 0; i < quantityDiv; i++) {
        const elementTd = document.getElementById(`tag_${i}_${legalSearchId}`)
        if(!elementTd) {
          continue
        }
        elements.push(elementTd)
      }
      const rects = elements.map(el => el.getBoundingClientRect())
      const top = Math.min(...rects.map(r => r.top))
      const left = Math.min(...rects.map(r => r.left))
      const right = Math.max(...rects.map(r => r.right))
      const bottom = Math.max(...rects.map(r => r.bottom))
      const box = document.createElement('div')
      box.style.position = 'fixed'
      box.style.top = `${top}px`
      box.style.left = `${left}px`
      box.style.width = `${right - left}px`
      box.style.height = `${bottom - top}px`
      box.style.pointerEvents = 'none'
      box.style.zIndex = '9999'
      box.classList.add('driver-highlight-box')
      document.body.appendChild(box)
      box.classList.add('driver-highlight-box')

      document.body.appendChild(box)
      return box
    },

    startTour() {
      const steps = [
        {
          element: this.$refs.agenBaseAutocomplete.$el,
          popover: {
            title: `
             <section class="custom-popover-header d-flex justify-content-between align-items-center">
               <span>Campo de pesquisa de agente</span>
               <svg onclick="window.closeTutorial()" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <g clip-path="url(#clip0_7174_5387)">
               <path d="M20.0024 2.23254L12.0024 10.2325L4.00237 2.23254L2.23438 4.00004L10.2349 12L2.23438 20L4.00237 21.7675L12.0024 13.7675L20.0024 21.7675L21.7704 20L13.7699 12L21.7704 4.00004L20.0024 2.23254Z" fill="#262626"/>
               </g>
               <defs>
               <clipPath id="clip0_7174_5387">
               <rect width="24" height="24" fill="white"/>
               </clipPath>
               </defs>
               </svg>
             </section>
           `,
            description: `
             <div class="custom-description">
               <span>Digite aqui o nome do agente químico ou o número CAS para começar a sua pesquisa.</span>
             </div>
           `,
            position: 'top',
            showButtons: [],
            side: 'top',
            align: 'center'
          }
        }
      ]
      this.addStepsTour(steps)
    },

    closeTour() {
      if (this.driver) {
        this.driver.destroy()
      }
    },

    manageTour() {
      if (this.noModalBeingShown) {
        const { showTourAfter3Logins } = this.user || {}
        this.showTour = showTourAfter3Logins
        this.$nextTick(() => {
          setTimeout(() => {
            window.closeTour = this.closeTour
            window.closeTutorial = this.closeTutorial
            this.startTour()
          }, 1000)
        })
      } else {
        this.closeTour()
      }
    },

    async closeTutorial() {
      this.closeTour()
      this.showTour = false
      const { id } = this.user || {}
      await this.handleUpdateHasSeenTourlAfter3Logins(id)
      this.$forceUpdate()
    },

    refreshTour() {
      if (this.driver) {
        this.driver.refresh()
      }
    },

    hasRoleNotLinkedToTheProduct(roleProductLegalConsultation){
      if(roleProductLegalConsultation && roleProductLegalConsultation.length > 0){
        for (const item of roleProductLegalConsultation) {
          if(item && item.role && (!item.role.sectorsRoles || item.role.sectorsRoles.length <= 0)){
            return true
          }
        }
      }
      return false
    },

    handleClickOutsideContainerAgenBaseAutocomplete(event) {
      const div = this.$refs.containerAgenBaseAutocomplete;
      if (div && !div.contains(event.target)) {
        this.showAgentes = false;
      }
    },

    async orderBy(orderBy) {
      await this.setSkip(1)
      await this.handleSetSummaryMetaOrderBy(orderBy)
      await this.load()
    },

    rowspan(legalConsultationAgentsGroupedByProduct, legalSearch){
      if(legalConsultationAgentsGroupedByProduct.product._id === `-`){
        return 1
      } else {
        return legalConsultationAgentsGroupedByProduct.legalSearches.length
      }
    },

    callGlobalCustomEvent(event, productId) {
      eventBus.$emit(event, productId)
    },

    showModalAddAgentsProduct(){
      this.$refs['add-agents-to-product'].show()
    },

    closeModalAddAgentsProduct(){
      this.$refs['add-agents-to-product'].hide()
    },

    async showModalSelectProduct() {
      this.products = []
      this.productId = null
      this.$refs['select-product'].show()
      const { data } = await this.handleGetProductLegalConsultationByCompany(this.importedCompany._id)
      const { products } = data
      this.products = products
    },

    closeModalSelectProduct(){
      this.$refs['select-product'].hide()
    },

    showModalSelectAgents(product){
      this.agentsSelected = []
      this.product = product.product
      this.$refs['select-agents'].show()
    },

    closeModalSelectAgents(){
      this.$refs['select-agents'].hide()
    },

    async addAgentProductSelected() {
      try {
        this.loadingAgents = true
        await this.handleAddAgentProductLegalConsultation(
          {
            user: this.user.id,
            productId: this.productId,
            legalSearchesId: this.selectedAgents,
            companyId: this.importedCompany && this.importedCompany._id ? this.importedCompany._id : null
          }
        )

        await this.handleUpdateAgentsCompanyLegalConsultation(
          {
            companyId: this.importedCompany._id,
            legalSearchesId: this.selectedAgents
          }
        )
        await this.load();
        this.loadingAgents = false
        this.closeModalSelectProduct()
        this.closeModalAddAgentsProduct()
        this.callGlobalCustomEvent('clearItems')
      } catch (e) { }
    },

    async addAgentsToTheProduct() {
      try {
        this.loadingAgents = true
        await this.handleAddAgentProductLegalConsultation(
          {
            user: this.user.id,
            productId: this.product._id,
            legalSearchesId: this.agentsSelected,
            companyId: this.importedCompany && this.importedCompany._id ? this.importedCompany._id : null
          }
        )

        await this.handleUpdateAgentsCompanyLegalConsultation(
          {
            companyId: this.importedCompany._id,
            legalSearchesId: this.agentsSelected
          }
        )
        await this.load();
        this.loadingAgents = false
        this.closeModalSelectAgents()
        this.closeModalAddAgentsProduct()
        this.callGlobalCustomEvent('clearItems')
      } catch (e) { }
    },

    async addAgentProduct(legalSearchId) {
      this.callGlobalCustomEvent('clearItems')
      const legalSearchesGroupedBySelectedAux = []
      this.legalConsultationAgentsGroupedByProduct.forEach((x) => {
        x.legalSearches.forEach((y) => {
          if (!y.registeredProduct) {
            delete y.product
          }
          legalSearchesGroupedBySelectedAux.push(y)
        })
      })
      await this.groupAgents(legalSearchesGroupedBySelectedAux)
      this.$emit('select', legalSearchId)
      this.showModalAddAgentsProduct()
    },

    addAgentsProduct(){
      this.closeModalAddAgentsProduct()
      this.callGlobalCustomEvent('showModalAddProduct')
    },

    async filter() {
      await this.setSkip(1)
      await this.summaryClear()
      this.$refs.filter.hide();
      await this.load();
    },

    async resetSummaryMeta() {
      await this.summaryClear()
      await this.setSkip(1)
      this.$refs.filter.hide();
      await this.handleResetSummaryMeta();
      await this.load();
    },

    showModalFilter(){
      this.$refs.filter.show()
    },

    styleWidth(field){
      switch (field.key) {
        case 'searchId':
          return 'max-width : 200px'
        default:
          return 'width : 120px'
      }
    },

    async add() {
      try {
        this.legalSearchesId = []
        this.disabled = true
        const userReachedLimitAddedAgents = this.userReachedLimitAddedAgents();
        if(userReachedLimitAddedAgents){
          this.selectedAgent = undefined
          this.$refs.agenBaseAutocomplete.value = ''
          this.$emit('daily-searches', this.limitationOfAgentsAdded)
          return
        }

        if(this.summaryMeta.total >= this.limitAgentsAddedInAgentSelection){
          this.selectedAgent = undefined
          this.$refs.agenBaseAutocomplete.value = ''
          const title = 'Atingido o limite de agentes adicionados';
          const message = `Para adicionar mais agentes é necessário apagar agentes para adicionar outros, o limte de agentes adicionados é ${this.limitAgentsAddedInAgentSelection}!`
          this.$emit('addedAgentLimits', title, message)
          return
        }
        let orderingDate = null
        let firstLegalConsultationAgentsGroupedByProduct = this.legalConsultationAgentsGroupedByProduct.at(0)
        if (this.summaryMeta.skip > 1 && this.legalConsultationAgentsGroupedByProduct.find(x => x.product && x.product._id && x.product._id === '-') && this.legalConsultationAgentsGroupedByProduct.length === 1){
          const firstPaginationAgent = this.summary.at(0)
          if (firstPaginationAgent && firstPaginationAgent.orderingDate) {
            orderingDate = moment(new Date(this.summary.at(0).orderingDate)).add(-1, 'second').toDate();
          }
        } else if (this.summaryMeta.skip > 1 && firstLegalConsultationAgentsGroupedByProduct && firstLegalConsultationAgentsGroupedByProduct.product && firstLegalConsultationAgentsGroupedByProduct.product._id && firstLegalConsultationAgentsGroupedByProduct.product._id === '-') {
          const { legalSearches } = firstLegalConsultationAgentsGroupedByProduct
          const [firstPaginationAgent] = legalSearches
          if (firstPaginationAgent && firstPaginationAgent.orderingDate) {
            orderingDate = moment(new Date(firstPaginationAgent.orderingDate)).add(-1, 'second').toDate();
          }
        }

        const { status, body, agent } = (
          await this.$store.dispatch('legalSearch/add', {
            user: this.user.id,
            agent: this.selectedAgent._id,
            name: this.selectedAgent.searchMatched,
            riskType: this.selectedAgent.riskType,
            orderingDate,
            acgih_data: {},
          })
        ).data

        if (status === 204) {
          this.$emit('daily-searches', body)
          return
        }

        this.$refs.agenBaseAutocomplete.value = ''
        await this.load()
        const { _id } = body
        const highlightBox = this.createHighlightBox(_id, 6)
        this.addStepsTour([
          {
            element: highlightBox,
            popover: {
              title: `
             <section class="custom-popover-header d-flex justify-content-between align-items-center">
               <span>Implementações</span>
             </section>
           `,
              description: `
             <div class="custom-description">
               <span>
               Conforme o agente selecionado anteriormente, agora você poderá saber se ele tem relação ou não com as normativas
               indicadas abaixo. Atenção: a indicação do agente na norma não quer dizer que ele enquadra automaticamente!
               Sempre verifique as condições conforme as abas de funcionalidade/finalidade.
              </span>

               <br/>
               <br/>
               <button onclick="window.closeTutorial()">Fechar tutorial</button>
             </div>
           `,
              position: 'top',
              showButtons: [],
              side: 'bottom',
              align: 'center'
            }
          },
        ])
        if (this.summaryMeta.skip > 1 && !orderingDate){
          await this.addAgentsStartList(agent)
          this.legalConsultationAgentsGroupedByProduct.unshift({
            product: {
              _id: "-",
              name: "-",
              description: "-",
              createdAt: this.user.currentDate
            },
            legalSearches: [...this.agentsStartList]
          })
        }
        await this.$store.dispatch('legalSearch/finishInsertionAgents', {
          user: this.user.id,
          agent: this.selectedAgent._id,
          planId: this.user && this.user.plan && this.user.plan._id ? this.user.plan._id : null,
          name: this.selectedAgent.searchMatched,
        })

        const sessionId = localStorage.getItem("sessionId");
        await this.$api.delete(`users/cache/${sessionId}`);
        const user = (await this.$api.get(`users/${sessionId}`)).data;
        await this.$store.dispatch('user/updateUser', user);
        await this.handleGetAddedAgentsLimitation(this.user)
        this.legalSearchesId.push(_id)
        if (this.importedCompany && this.importedCompany._id) {
          const bodyAddAgentCompany = {
            user: this.user.id,
            companyId: this.importedCompany._id,
            legalSearchesId: this.legalSearchesId
          }
          await this.handleAddAgentCompanyLegalConsultation(bodyAddAgentCompany)

          this.$bvToast.toast(`As informações da empresa foram atualizadas.`, {
            title: 'Atenção',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 6000,
          });
        } else {
          await this.handleAddAgentsFreeModeAgents(
            {
              user: this.user.id,
              agents: this.legalSearchesId
            }
          )
        }
        this.selectedAgent = undefined
      } catch (err) {
        console.log(err)
      }
    },

    checked(id) {
      return this.itemsToRemove.indexOf(id) >= 0
    },

    clear() {
      if (this.$refs.agenBaseAutocomplete.value === '') {
        this.selectedAgent = undefined
        this.disabled = true
      }
    },

    async load() {
      this.loading = false
      await this.$store.dispatch('legalSearch/load', this.user.id)
      await this.loadAgentsByRisk()
    },

    async loadAgentsByRisk() {
      this.loading = false
      await this.setLookingForAgents(true)
      await this.handleGetLoadAgentsByRisk({userId: this.user.id })
      await this.setLookingForAgents(false)
    },

    async remove() {
      await this.$store.dispatch('legalSearch/remove', this.itemsToRemove)
      this.itemsToRemove = []
      await this.load()
      this.$refs.rmconfirmation.hide()
    },

    removeConfirmation(i) {
      this.itemsToRemove.push(i)
      this.$refs.rmconfirmation.show()
    },

    select(id) {
      let index = this.itemsToRemove.indexOf(id)
      if (index >= 0) {
        this.itemsToRemove.splice(index, 1)
      } else {
        this.itemsToRemove.push(id)
      }
    },

    async selectByAgente(item) {
      this.loading = false
      let agent = item
      this.hitted = true
      this.options = this.agents.filter((item) => {
        if (agent.searchMatched === item.searchMatched) return item
      })
      this.selectedAgent = item
      this.agent = ''
      this.agents = []
      this.disabled = false
      this.showAgentes = false
      this.closeTour()
      await this.add()
      await this.handleUpdateChangedAgentsLegalConsultation(true)
    },

    extractStringCas(){
      this.agent = this.cas
      this.$refs.agenBaseAutocomplete.value = extractCASNumber(this.agent)
      this.$refs['alert-cas'].hide()
      this.searchChemicalAgents(extractCASNumber(this.cas))
    },

    searchWithoutExtractingCASNumber(){
      this.$refs['alert-cas'].hide()
      this.searchChemicalAgents(this.agent)
    },

    async searchChemicalAgents(newQuery) {
      try {
        this.loading = true
        this.casSearch = newQuery
        const response = (await this.$api.get(`agents/search?agent=${newQuery}`)).data
        this.agents = response.chemicalAgents
        if (response.chemicalAgents.length <= 0) {
          this.closeTour()
          this.modal.current = response.searchedByCas ? 'ModalRequestAgent' : 'ModalAgentNotFound'
          this.modal.open = true
          this.$emit('open-modal', { modal: this.modal, agent: this.agent, casSearch: this.casSearch })
        }
        await this.handleCreateSearchAgents({user: this.user.id, researched: newQuery})
        this.loading = false
      } catch (e) {

      } finally {
        this.loading = false

      }
    },

    userReachedLimitAddedAgents(){
      return this.limitationOfAgentsAdded && this.limitationOfAgentsAdded.limitation <= this.limitationOfAgentsAdded.added ;
    },

    async selectAll() {
      await this.$emit('select-all')

      const agentes = this.summary.filter((x) => this.itemsToRemove.includes(x.legalSearchId))
      const agentesVinculadoProduto = agentes.filter((x) => x.product && x.product._id)
      const agentesVinculadoProdutoAgrupadoPorProduto = agentesVinculadoProduto.reduce((group, agent) => {
        const product = agent.product._id
        group[product] = group[product] ? group[product] : []
        group[product].push(agent)
        return group
      }, {})

      if (Object.keys(agentesVinculadoProdutoAgrupadoPorProduto).length === 1) {
        const legalSearchesGroupedBySelectedAux = []
        this.legalConsultationAgentsGroupedByProduct.forEach((x) => {
          legalSearchesGroupedBySelectedAux.push(...x.legalSearches)
        })

        let productAgent = null
        const legalSearchesProducts = legalSearchesGroupedBySelectedAux.filter((x) => this.itemsToRemove.includes(x.legalSearchId) && x.product && x.product._id && x.registeredProduct)
        if (legalSearchesProducts.length > 0) {
          const [legalSearch] = legalSearchesProducts
          const { product } = legalSearch
          if (product) {
            productAgent = product
          }
        }

        legalSearchesGroupedBySelectedAux.forEach((x) => {
          if(!x.product || !x.registeredProduct){
            x.product = productAgent
          }
        })
        await this.groupAgents(legalSearchesGroupedBySelectedAux)
      } else {
        this.summary.forEach((x) => {
          if (!x.registeredProduct) {
            delete x.product
          }
        })
        await this.groupAgents(this.summary)
      }
    },

    async selectAgentRemove(legalSearch) {
      const { legalSearchId, product, registeredProduct } = legalSearch;
      await this.$emit('select', legalSearchId)

      const legalSearchesGroupedBySelectedAux = []

      this.legalConsultationAgentsGroupedByProduct.forEach((x) => {
        legalSearchesGroupedBySelectedAux.push(...x.legalSearches)
      })

      const legalSearchesProducts = legalSearchesGroupedBySelectedAux.filter((x) => this.itemsToRemove.includes(x.legalSearchId) && x.product && x.product._id && x.registeredProduct)
      const legalSearchesProductsGroupBy = legalSearchesProducts.reduce((group, agent) => {
        const product = agent.product && agent.product._id ? agent.product._id : `-`;
        group[product] = group[product] ? group[product] : [];
        group[product].push(agent);
        return group;
      }, {})

      if (Object.keys(legalSearchesProductsGroupBy).length >= 2) {
        this.$bvToast.toast(`Não é possível vincular um agente químico em dois ou mais produtos de uma vez.`, {
          title: 'Aviso',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.$emit('select', legalSearchId)
        return
      }
      let productAgent = null

      if (this.checked(legalSearchId)) {
        if (product && product._id && product._id && registeredProduct) {
          const legalSearchesProductsGroupBy = legalSearchesGroupedBySelectedAux.filter((x) => this.itemsToRemove.includes(x.legalSearchId) && x.product && x.product._id && !x.registeredProduct)
          if (legalSearchesProducts.length > 0) {
            const [legalSearch] = legalSearchesProducts
            const { product } = legalSearch
            if (product) {
              productAgent = product
            }
          }
          legalSearchesGroupedBySelectedAux.forEach((x) => {
             const legalSearchesGroupedBy = legalSearchesProductsGroupBy.find((y) => y.legalSearchId === x.legalSearchId)
              if(legalSearchesGroupedBy){
                x.product = productAgent
              }
          })
        } else {
          if (legalSearchesProducts.length > 0) {
            const [legalSearch] = legalSearchesProducts
            const { product } = legalSearch
            if (product) {
              productAgent = product
              productAgent.groupBy = true
            }
          }
          legalSearchesGroupedBySelectedAux.forEach((x) => {
            if (x.legalSearchId === legalSearchId) {
              x.product = productAgent ? productAgent : {
                _id: this.idDefault,
                name: undefined,
                description: undefined,
              }
            }
          })
        }
      } else {
        legalSearchesGroupedBySelectedAux.forEach((x) => {
          if(!x.registeredProduct && x.legalSearchId === legalSearchId) {
            delete x.product
          } else if(x.registeredProduct && x.legalSearchId === legalSearchId) {
            const legalSearchesProductsGroupBy = legalSearchesGroupedBySelectedAux.filter((x) => this.itemsToRemove.includes(x.legalSearchId) && x.product && x.product._id && x.registeredProduct)
            if (legalSearchesProductsGroupBy.length === 0 && this.itemsToRemove.length > 0) {
              const legalSearchesProductsGroupByNotRegisteredProduct = legalSearchesGroupedBySelectedAux.filter((x) => this.itemsToRemove.includes(x.legalSearchId) && x.product && x.product._id && !x.registeredProduct)
              legalSearchesGroupedBySelectedAux.forEach((x) => {
                const legalSearchesGroupedBy = legalSearchesProductsGroupByNotRegisteredProduct.find((y) => y.legalSearchId === x.legalSearchId)
                if (legalSearchesGroupedBy) {
                  x.product = { _id: this.idDefault, name: undefined, description: undefined}
                }
              })
            }
          }
        })
      }

      await this.groupAgents(legalSearchesGroupedBySelectedAux)
    },

    showAddAgents(product){
      const { legalSearches } = product
      const agents = legalSearches && legalSearches.length > 0 ? legalSearches.filter((f) => f.registeredProduct).map((x) => x.legalSearchId) : []
      const selecionouAgentesSemVinculoProuto = this.itemsToRemove.some((element) => !(agents.find((x) => x === element)));
      const naoSelecionouAgentesSemVinculoProuto = this.itemsToRemove.some((element) => (!!(agents.find((x) => x === element))));
      return selecionouAgentesSemVinculoProuto && naoSelecionouAgentesSemVinculoProuto;
    },

    async groupAgents(agents) {
      try {
        const legalConsultationAgentsGroupedByProduct = []

        const legalSearchGroupByProduct = agents.reduce((group, agent) => {
          const product = agent.product && agent.product._id ? agent.product._id : `-`;
          group[product] = group[product] ? group[product] : [];
          group[product].push(agent);
          return group;
        }, {})

        Object.keys(legalSearchGroupByProduct).forEach((legalSearchGroupBy) => {
          const product = legalSearchGroupByProduct[legalSearchGroupBy].find((agent) => agent && agent.product && agent.product._id && agent.product._id.toString() === legalSearchGroupBy)
          const createdAt = product && product.createdAt ? product.createdAt : new Date()
          legalConsultationAgentsGroupedByProduct.push(
            {
              product: legalSearchGroupBy !== `-`
                ? legalSearchGroupByProduct[legalSearchGroupBy].find((agent) => agent && agent.product && agent.product._id && agent.product._id.toString() === legalSearchGroupBy).product
                : { _id: `-`, name: `-`, description: `-`, createdAt},
                legalSearches: legalSearchGroupByProduct[legalSearchGroupBy].map((x, index) => {
                const legalSearch = x
                legalSearch.index = index
                return legalSearch
              })
            }
          )
        })
        await this.setLegalConsultationAgentsGroupedByProduct(legalConsultationAgentsGroupedByProduct)
      } catch (e) {

      }
    },

    normalized(text) {
      return text
        ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        : ''
    }
  },
  computed: {
    perPage(){
      const { totalPage, total } = this.summaryMeta
      return Math.ceil(total / totalPage)
    },
    tr() {
      return tr
    },
    ...mapGetters('legalSearch', {
      summary: 'summary',
      agentsWithoutProduct: 'agentsWithoutProduct',
      selectedAgents: 'selectedAgents',
      legalConsultationAgentsPhysicalRisk: 'legalConsultationAgentsPhysicalRisk',
      legalConsultationAgentsBiologicalRisk: 'legalConsultationAgentsBiologicalRisk',
    }),
    selectedPhysicalAgentIds() {
      const physicalIds = new Set()
      this.legalConsultationAgentsPhysicalRisk.forEach(group => {
        group.legalSearches.forEach(item => physicalIds.add(item.legalSearchId))
      })
      return this.itemsToRemove.filter(id => physicalIds.has(id))
    },
    hasSelectedPhysicalAgents() {
      return this.selectedPhysicalAgentIds.length > 0
    },
    ...mapGetters('userPlans', {
      limitationOfAgentsAdded: 'limitationOfAgentsAdded'
    }),
    filterAgents(){
      const agentsNormalized = this.agent
        ? this.normalized(this.agent).toUpperCase()
        : ''

      return this.agents.filter(x => this.normalized(x.searchMatched).toUpperCase().includes(agentsNormalized))
    },
    selectedAgent: {
      get: function () {
        return this.$store.getters['legalSearch/selectedAgent']
      },
      set: function (agent) {
        this.$store.dispatch('legalSearch/select', agent)
      },
    },
    user() {
      return this.$store.getters['user/current']
    },
    releaseAcgih() {
      return this.$store.getters['user/releaseAcgih']
    },
    agentsPerPage() {
      return this.$store.getters['legalSearch/agentsPerPage']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    },
    legalConsultationAgentsGroupedByProduct() {
      return this.$store.getters['legalSearch/legalConsultationAgentsGroupedByProduct']
    },
    agentsStartList() {
      return this.$store.getters['legalSearch/agentsStartList']
    },
    lookingForAgents() {
      return this.$store.getters['legalSearch/lookingForAgents']
    },
    appliedFilters() {
      return this.$store.getters['legalSearch/appliedFilters']
    },
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    ...mapGetters('productLegalConsultation', {
      disableProduct: 'disableProduct'
    }),
    selectedMoreThanOneProduct(){
      const agentes = this.summary.filter((x) => this.itemsToRemove.includes(x.legalSearchId))
      const agentesVinculadoProduto = agentes.filter((x) => x.product && x.product._id)
      const agentesVinculadoProdutoAgrupadoPorProduto = agentesVinculadoProduto.reduce((group, agent) => {
        const product = agent.product._id
        group[product] = group[product] ? group[product] : []
        group[product].push(agent)
        return group
      }, {})
      return Object.keys(agentesVinculadoProdutoAgrupadoPorProduto).length >= 2
    },
    synergisticRiskProducts() {
      return this.$store.getters['legalSearch/synergisticRiskProducts']
    },
    synergisticRiskRoles() {
      return this.$store.getters['legalSearch/synergisticRiskRoles']
    },
    ...mapGetters('access', {
      noModalBeingShown: 'noModalBeingShown'
    }),
    ...mapGetters('userPreferences', {
      userPreferences: 'userPreferences',
    }),
  },
  watch: {
    agent: _.debounce(async function (newQuery) {
      if (!newQuery || newQuery.length < 3) return
      const text = extractString(newQuery);
      const cas = extractCASNumber(newQuery);
      if(agentCASNumberIsValid(cas) && text && text.length > 0){
        this.cas = cas
        this.$refs['alert-cas'].show()
        return
      }
      await this.searchChemicalAgents(newQuery)
      if(this.agents && this.agents.length > 0 && this.showTour) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.addStepsTour([
              {
                element: '#container-li-agents',
                popover: {
                  title: `
              <section class="custom-popover-header d-flex justify-content-between align-items-center">
                <span>Retorno da pesquisa</span>
                <svg onclick="window.closeTutorial()" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7174_5387)">
                <path d="M20.0024 2.23254L12.0024 10.2325L4.00237 2.23254L2.23438 4.00004L10.2349 12L2.23438 20L4.00237 21.7675L12.0024 13.7675L20.0024 21.7675L21.7704 20L13.7699 12L21.7704 4.00004L20.0024 2.23254Z" fill="#262626"/>
                </g>
                <defs>
                <clipPath id="clip0_7174_5387">
                <rect width="24" height="24" fill="white"/>
                </clipPath>
                </defs>
                </svg>
              </section>
            `,
                  description: `
              <div class="custom-description">
                <span>Clique com o botão esquerdo do mouse sobre a opção desejada e então comece a ver as informações desse agente.</span>
              </div>
            `,
                  showButtons: [],
                  side: 'bottom',      // 🔥 correto no v1+
                  align: 'center'
                }
              },
            ])
          }, 100)
        })
      }
    }, 1500),
    noModalBeingShown(){
      this.manageTour()
    }
  },
}
</script>
<style lang='scss'>
.hover_links{
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  color: #04A8F3;
}
.width-8-percent{
  width: 8%!important;
}
.w-60{
  width: 60%!important;
}
.w-40{
  width: 40%!important;
}
.width-44-percent{
  width: 44%!important;
}
.options {
  border-radius: 6px !important;
  min-width: 590px!important;
}
.btn-options {
  border-radius: 5px !important;
  background: transparent !important;
  border: 1px solid transparent!important;
  width: 5px!important;
  text-align: center;
}
.btn-options:active {
  border: 1px solid transparent!important;
}

.headerMinWidth{
  min-width: 200px
}
.sticky {
  position: sticky;
  top: 10px;
  z-index: 10;
}
.summary-table {
  border-collapse: separate;
  border-spacing: 0;
}
.border-radius-th{
  border-radius: 10px 10px 0 0 !important;
  background-color: #022245;
}
.search-agent {
  height: 90px;
  z-index: 11;
}

.container-tab-buttons{
  padding: 0 0 3px 0!important;
}
.loading{
  width: 2.5rem;
  height: 2.5rem;
}
button.button-inventory:not(:disabled) {
  background-color: green;
}
.legal-search > .form-control {
  background-image: url('/img/loading.gif');
}
.loadingLookingForAgents{
  width: 2rem;
  height: 2rem;
}
.text-loading{
  font-size: 18px;
}

.text-opcoes-relavao-legal{
  font-size: 16px;
}
.add-agent-prouct{
  color:  #04A8F3;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration-line: underline;
  cursor: pointer;
  min-width: 85px;
}
.btn-synergistic-risk{
  width: 32px!important;
  height: 32px!important;
  background: #CBD63E!important;
  border: 1px solid #022245;
  border-radius: 2px;
}
.phrases{
  list-style: inside;
  margin-left: 20px;
  li{
    list-style-position: outside;
  }
}
#container-li-agents{
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  max-height: 350px;
  overflow-y : auto;
  overflow-x : hidden;
  background: #FFFFFF;
  scrollbar-width: thin 12px;
  border-radius: 5px;
  li {
    border-bottom: 1px solid #C0C0C0;
    padding: 12px 10px;
  }
  li:hover {
    background: #94D5F3;
  }
}
.list-agents{
  z-index: 9999;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  max-height: 350px;
  overflow-y : auto;
  overflow-x : hidden;
  background: #FFFFFF;
  scrollbar-width: thin 12px;
  border-radius: 5px;
  li {
    border-bottom: 1px solid #C0C0C0;
    padding: 12px 10px;
  }
  li:hover {
    background: #94D5F3;
  }
}
.list-agents::-webkit-scrollbar {
  width: 15px;
}

.list-agents::-webkit-scrollbar-track {
  background: #ffffff;
}

.list-agents::-webkit-scrollbar-thumb {
  background: #022245;
  border-radius: 20px;
  border: 3px solid #ffffff;
  -webkit-box-shadow: inset 0 0 6px #022245;
  height: 230px!important;
}
.name-sector-role{
  font-weight: 400;
  font-size: 17px;
  color: #000000;
}
.custom-popover-header{
  padding: 0 5px!important;
  span{
    font-family: 'Montserrat', serif !important;
    color: var(--navy-blue);
    font-weight: 600;
    font-size: 20px;
  }
}
.custom-description{
  padding: 0 30px 0 5px!important;
  span{
    color: #808080;
    font-size: 16px;
    font-family: 'Montserrat', serif !important;
  }
  button {
    width: 100%!important;
    background: transparent;
    border: 1px solid var(--navy-blue);
    color: var(--navy-blue);
    text-align: center;
    padding: 10px;
    font-size: 18px;
    border-radius: 5px;
  }
}
.driver-popover {
  min-width: 500px;
  width: auto;
  border-radius: 8px;
}


.risk-chemical-tbody td{
  border: 0.5px solid #EDEDED;
}

.risk-chemical-header-row th {
  background: #94D5F3 !important;
  padding: 14px 16px !important;
  border: 0.5px solid #EDEDED;
}


.risk-chemical-header-row-physical-risk th {
  background: #CCE5D2 !important;
  padding: 14px 16px !important;
  border: none;
}

.risk-chemical-header-row-biological-risk th {
  background: #E3BEB0 !important;
  padding: 14px 16px !important;
  border: none;
}

.risk-chemical-title {
  font-weight: bold!important;
  font-size: 18px;
  color: #262626;
}

.risk-chemical-toggle {
  background: transparent;
  border: 1px solid #022245;
  border-radius: 6px;
  color: #022245;
  font-weight: 600;
  font-size: 16px;
  padding: 6px 16px;
}
#agentsByPhysicalRisk, #agentsByBiologicalRisk{
  margin-top: 0px!important;
}
</style>
